<template>
  <div class="parent-product-mgmt-page purchase-mgmt-page">
    <div ref="header" class="page-header">
      <div class="filter-card header-box">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">状态</span>
            <el-select placeholder="请选择" size="small" v-model="statusFilter" clearable>
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="toolbar-tip">共 {{ products.length }} 条</span>
          </div>
        </div>
        <div class="filter-toolbar">
          <div class="filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="getAllProducts">查询</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-plus" @click="onAddProductBtnClick">新增</el-button>
            <el-button size="small" @click="goColorMgmt">颜色管理</el-button>
            <el-button size="small" plain>
              <download-excel :data="productData" :fields="productTitles" :name="getExportProductName()">导出商品</download-excel>
            </el-button>
            <el-button size="small" plain :disabled="loading" @click="openConvertExport">转换导出</el-button>
            <el-button size="small" plain>
              <download-excel :data="fbaFees" :fields="fbaFeeTitles" :name="getExportFBAFeeName()">导出 FBA Fee</download-excel>
            </el-button>
          </div>
          <div class="batch-toolbar" v-if="multipleSelection.length > 0">
            <span class="toolbar-tip">已选 {{ multipleSelection.length }} 条，可导出商品描述</span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table
          :data="products"
          border
          stripe
          size="mini"
          :height="screenHeight"
          class="mgmt-table"
          header-cell-class-name="table-header-cell"
          v-loading="loading"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
          @selection-change="handleSelectionChange"
        >
      <el-table-column type="selection" width="48" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" width="64" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status == 1 ? 'success' : 'info'" size="mini" effect="plain">
            {{ scope.row.status == 1 ? "启用" : "停用" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="序号" width="52" align="center">
        <template slot-scope="scope">
          {{ beginIndex + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="productType" label="类型编码" width="80" sortable align="center"></el-table-column>
      <el-table-column prop="country" label="站点" width="76" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.country == 2 ? 'warning' : ''" size="mini" effect="plain">
            {{ scope.row.country == 2 ? "日本" : "美国" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="shopName" label="店铺" width="88" show-overflow-tooltip></el-table-column>
      <el-table-column prop="productName" label="产品名称" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="报关名称" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">{{ getCustomsName(scope.row) }}</template>
      </el-table-column>
      <el-table-column label="开票项目名称" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="invoice-name-cell">{{ getInvoiceProjectNameDisplay(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="skuPrefix" label="SKU前缀" min-width="140" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column prop="标题和五点描述" width="500px">
        <template v-slot="scope">
          <div style="height: 50px; overflow: auto">
            <div>标题 :{{ scope.row.title }}</div>
            <div>五点描述1:{{ scope.row.des1 }}</div>
            <div>五点描述2:{{ scope.row.des2 }}</div>
            <div>五点描述3:{{ scope.row.des3 }}</div>
            <div>五点描述4:{{ scope.row.des4 }}</div>
            <div>五点描述5:{{ scope.row.des5 }}</div>
            <template v-if="scope.row.categoryType == 2 || scope.row.categoryType == 3">
              <div>五点描述1:{{ scope.row.des6 }}</div>
              <div>五点描述2:{{ scope.row.des7 }}</div>
              <div>五点描述3:{{ scope.row.des8 }}</div>
              <div>五点描述4:{{ scope.row.des9 }}</div>
              <div>五点描述5:{{ scope.row.des10 }}</div>
            </template>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="机型" width="200px">
        <template v-slot="scope">
          <div style="height: 50px; overflow: auto">{{ scope.row.checkColors && JSON.parse(scope.row.checkModels).join(",") }}</div>
        </template>
      </el-table-column> -->
      <el-table-column prop="defaultModel" label="主推机型" width="100" show-overflow-tooltip></el-table-column>
      <el-table-column label="主推颜色" width="88" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.defaultColorName || getColorName(scope.row.defaultColor) || scope.row.defaultColor || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="isMajorProduct" label="主推款" width="72" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isMajorProduct == 1" type="danger" size="mini" effect="plain">主推</el-tag>
          <span v-else class="text-muted">-</span>
        </template>
      </el-table-column>
      <el-table-column label="材料组合" min-width="180" sortable show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="material-config-cell">{{ getMaterialConfigText(scope.row.materialConfig) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cost" label="采购成本" width="80" align="right" sortable class-name="amount-col">
        <template slot-scope="scope">
          {{ scope.row.cost != null ? scope.row.cost.toFixed(1) : "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="perSKUOrderQuantity" label="起订量" width="72" align="right" sortable class-name="amount-col">
        <template slot-scope="scope">
          {{ scope.row.perSKUOrderQuantity > 0 ? scope.row.perSKUOrderQuantity : 5 }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right" align="center" class-name="action-col">
        <template slot-scope="scope">
          <div class="action-cell">
            <el-button type="text" size="small" @click="editProduct(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="childProduct(scope.row)">子商品</el-button>
            <el-button type="text" size="small" @click="onlineStatus(scope.row)">上线情况</el-button>
            <el-dropdown trigger="click" @command="cmd => handleRowAction(cmd, scope.row)">
              <el-button type="text" size="small">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delivery">投放词配置</el-dropdown-item>
                <el-dropdown-item command="keyword">关键词分析</el-dropdown-item>
                <el-dropdown-item command="material">配置材料组合</el-dropdown-item>
                <el-dropdown-item command="invoice">编辑开票信息</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="新增父产品" :visible.sync="parentProductDialogVisible" :close-on-click-modal="false" width="1000px">
      <div class="form-line">
        <span class="form-label"><span>*</span>站点</span>
        <el-radio-group v-model="productInfo.country">
          <el-radio :label="1">美国</el-radio>
          <el-radio :label="2">日本</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>店铺名称</span>
        <el-radio-group v-model="productInfo.shopType">
          <el-radio :label="1">灵柚</el-radio>
          <el-radio :label="2">萧发</el-radio>
          <el-radio :label="3">誉腾</el-radio>
          <el-radio :label="4">甄昂</el-radio>
          <el-radio :label="8">众联</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>产品类目</span>
        <el-radio-group v-model="productInfo.categoryType">
          <el-radio :label="1">Basic Case</el-radio>
          <el-radio :label="2">Phone Stand</el-radio>
          <el-radio :label="3">Flip Case</el-radio>
          <el-radio :label="4">iPad Case</el-radio>
          <el-radio :label="5">Sleeves Case</el-radio>
          <el-radio :label="6">StarLink Case</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>产品名称</span>
        <el-input class="form-input" placeholder="请输入" v-model="productInfo.productName" size="small" clearable> </el-input>
      </div>
      <!-- <div class="form-line">
        <span class="form-label"><span>*</span>产品类型</span>
        <el-input class="form-input" placeholder="请输入" v-model="productInfo.productType" size="small" clearable>
        </el-input>
      </div> -->
      <div class="form-line">
        <span class="form-label"><span>*</span>SKU前缀</span>
        <el-input class="form-input" placeholder="请输入" v-model="productInfo.skuPrefix" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>SKU前缀2</span>
        <el-input class="form-input" placeholder="请输入" v-model="productInfo.skuPrefix2" size="small" clearable> </el-input>
      </div>

      <div class="form-line">
        <span class="form-label"><span>*</span>标题</span>
        <el-input class="form-input" placeholder="请输入" v-model="productInfo.title" type="textarea" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>五点描述1</span>
        <el-input class="form-input" placeholder="请输入" v-model="productInfo.des1" type="textarea" :rows="2" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">五点描述2</span>
        <el-input class="form-input" placeholder="请输入" v-model="productInfo.des2" type="textarea" :rows="2" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">五点描述3</span>
        <el-input class="form-input" placeholder="请输入" v-model="productInfo.des3" type="textarea" :rows="2" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">五点描述4</span>
        <el-input class="form-input" placeholder="请输入" v-model="productInfo.des4" type="textarea" :rows="2" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">五点描述5</span>
        <el-input class="form-input" placeholder="请输入" v-model="productInfo.des5" type="textarea" :rows="2" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">搜索词</span>
        <el-input class="form-input" placeholder="请输入" v-model="productInfo.searchTerms" type="textarea" :rows="2" size="small" clearable> </el-input>
      </div>
      <!-- <template v-if="productInfo.categoryType == 2 || productInfo.categoryType == 3 || productInfo.categoryType == 4">
        <div class="form-line">
          <span class="form-label">五点描述6</span>
          <el-input class="form-input" placeholder="请输入" v-model="productInfo.des6" type="textarea" :rows="2" size="small" clearable> </el-input>
        </div>
        <div class="form-line">
          <span class="form-label">五点描述7</span>
          <el-input class="form-input" placeholder="请输入" v-model="productInfo.des7" type="textarea" :rows="2" size="small" clearable> </el-input>
        </div>
        <div class="form-line">
          <span class="form-label">五点描述8</span>
          <el-input class="form-input" placeholder="请输入" v-model="productInfo.des8" type="textarea" :rows="2" size="small" clearable> </el-input>
        </div>
        <div class="form-line">
          <span class="form-label">五点描述9</span>
          <el-input class="form-input" placeholder="请输入" v-model="productInfo.des9" type="textarea" :rows="2" size="small" clearable> </el-input>
        </div>
        <div class="form-line">
          <span class="form-label">五点描述10</span>
          <el-input class="form-input" placeholder="请输入" v-model="productInfo.des10" type="textarea" :rows="2" size="small" clearable> </el-input>
        </div>
      </template> -->
      <div class="form-line">
        <span class="form-label"><span>*</span>型号</span>
        <el-checkbox @change="handleCheckNoneChange" v-model="productInfo.isHasModel" :true-label="0" :false-label="1">无</el-checkbox>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <el-checkbox-group v-show="productInfo.isHasModel == 1" class="form-group" v-model="productInfo.checkModels">
          <!-- <el-checkbox label="无型号"></el-checkbox> -->
          <el-checkbox v-for="item in iPhoneModels" :key="item.model" :label="item.model"></el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="form-line" v-show="productInfo.isHasModel == 1">
        <span class="form-label"><span>*</span>主推型号</span>
        <el-radio-group class="form-group" v-model="productInfo.defaultModel">
          <!-- <el-radio label="无型号"></el-radio> -->
          <el-radio v-for="item in checkedModels" :key="item.model" :label="item.model"></el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>颜色</span>
        <el-checkbox v-model="isColorEdit" :true-label="1" :false-label="2" style="margin-right: 5px">编辑</el-checkbox>
        <template v-if="isColorEdit == 1">
          <div class="color-box">
            <span class="color-item" v-for="color in colors" :key="color.key" @click="editColor(color)">{{ color.name }}</span>
          </div>
        </template>
        <template v-else>
          <el-button type="text" @click="addNewColor" style="margin-right: 41px">新增</el-button>
          <el-checkbox-group ref="colorRef" class="form-group" v-model="productInfo.checkColors">
            <!-- <el-checkbox label="无颜色"></el-checkbox> -->
            <!-- <el-checkbox v-if="productInfo.shopType == 7" v-for="color in colors" :key="color.jpKey" :label="color.key">{{ color.name }}</el-checkbox> -->
            <el-checkbox v-for="color in colors" :key="color.key" :label="color.key">{{ color.name }}</el-checkbox>
          </el-checkbox-group>
        </template>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>主推颜色</span>
        <el-radio-group v-model="productInfo.defaultColor">
          <!-- <el-radio label="无型号"></el-radio> -->
          <el-radio v-for="color in checkedColors" :key="color.key" :label="color.key">{{ color.name }}</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>成本</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="productInfo.cost" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>单SKU起订量</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="productInfo.perSKUOrderQuantity" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>是否主推款</span>
        <el-radio-group v-model="productInfo.isMajorProduct">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>状态</span>
        <el-switch v-model="productInfo.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"> </el-switch>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="parentProductDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmBtn">确 定</el-button>
      </div>

      <el-dialog width="450px" title="新增颜色" :visible.sync="colorDialogVisible" append-to-body>
        <div class="form-line">
          <span class="form-label"><span>*</span>颜色名称</span>
          <el-input class="form-input" placeholder="请输入" v-model="colorInfo.name" size="small" style="width: 300px; vertical-align: middle" clearable> </el-input>
        </div>
        <div class="form-line">
          <span class="form-label"><span>*</span>英文关键字</span>
          <el-input class="form-input" placeholder="请输入" v-model="colorInfo.key" size="small" style="width: 300px; vertical-align: middle" clearable> </el-input>
        </div>

        <div class="form-line">
          <span class="form-label"><span>*</span>日文关键字</span>
          <el-input class="form-input" placeholder="请输入" v-model="colorInfo.jpKey" size="small" style="width: 300px; vertical-align: middle" clearable> </el-input>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="colorDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleColorConfirmBtn">确 定</el-button>
        </div>
      </el-dialog>
    </el-dialog>

    <el-dialog width="600px" title="配置材料组合" :visible.sync="configMaterialDialogVisible" append-to-body>
      <div v-for="(config, index) in materialConfig" class="form-line">
        <span class="form-label"><span>*</span>材料{{ index + 1 }}</span>
        <el-select class="form-select" placeholder="请选择" size="small" v-model="config.materialColor" style="margin-right: 30px; vertical-align: middle" filterable>
          <el-option v-for="item in materialColorLists" :label="item.materialName" :value="item.materialColor"></el-option>
        </el-select>

        <span style="margin-right: 10px">数量</span>
        <el-input class="form-input" placeholder="请输入" v-model.number="config.count" size="small" type="number" style="width: 100px; vertical-align: middle; margin-right: 10px" clearable> </el-input>
        <span>个</span>

        <el-button type="text" @click="deleteMateral(index)" :data-index="index" style="margin-left: 10px">- 删除</el-button>
      </div>
      <div class="form-line">
        <el-button @click="addOneMaterial" type="text" style="margin-left: 90px">+ 新增材料</el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="configMaterialDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfigMaterialConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      width="820px"
      title="编辑开票信息"
      :visible.sync="invoiceInfoDialogVisible"
      append-to-body
      :close-on-click-modal="false"
      custom-class="parent-product-invoice-dialog"
    >
      <div class="invoice-dialog-body">
        <div class="invoice-section invoice-basic-section">
          <div class="invoice-section-header compact">
            <div class="invoice-section-title">基本信息</div>
          </div>
          <div class="invoice-product-summary">
            <div class="invoice-product-meta">
              <span class="invoice-product-type-tag">类型 {{ invoiceForm.productType || "-" }}</span>
              <span class="invoice-product-label">当前产品</span>
            </div>
            <div class="invoice-product-name" :title="invoiceForm.productName">{{ invoiceForm.productName || "-" }}</div>
          </div>
          <div class="invoice-form-panel">
            <div class="invoice-form-row">
              <label class="invoice-form-label">报关名称</label>
              <div class="invoice-form-content">
                <div class="invoice-input-row">
                  <el-input
                    v-model="invoiceForm.customsName"
                    size="small"
                    clearable
                    placeholder="请输入报关名称"
                    class="invoice-form-input"
                  ></el-input>
                  <el-button size="small" plain @click="resetCustomsName">恢复默认</el-button>
                </div>
                <div class="invoice-form-tip">未填写时默认等于产品名称，当前生效：{{ getEffectiveCustomsName() }}</div>
              </div>
            </div>
            <div class="invoice-form-row">
              <label class="invoice-form-label">开票项目名称</label>
              <div class="invoice-form-content">
                <el-input
                  v-model="invoiceForm.defaultInvoiceProjectName"
                  size="small"
                  clearable
                  placeholder="请输入开票项目名称"
                  class="invoice-form-input"
                ></el-input>
                <div class="invoice-form-tip">可为空；未单独配置供应商名称时，将使用该开票项目名称</div>
              </div>
            </div>
          </div>
        </div>

        <div class="invoice-section">
          <div class="invoice-section-header">
            <div class="invoice-section-title">供应商开票项目名称</div>
            <el-button type="primary" plain size="mini" icon="el-icon-plus" @click="addSupplierInvoiceProjectName">新增配置</el-button>
          </div>
          <el-table
            :data="invoiceForm.supplierInvoiceProjectNames"
            border
            stripe
            size="mini"
            max-height="280"
            empty-text="暂无供应商配置，可点击上方按钮新增"
            class="invoice-supplier-table"
          >
            <el-table-column label="序号" width="52" align="center">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column label="供应商" min-width="200">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.supplierId"
                  size="mini"
                  filterable
                  clearable
                  placeholder="请选择供应商"
                  style="width: 100%"
                  @change="onSupplierInvoiceProjectChange(scope.row)"
                >
                  <el-option
                    v-for="supplier in supplierList"
                    :key="supplier.supplierId"
                    :label="supplier.supplierShortName"
                    :value="supplier.supplierId"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="开票项目名称" min-width="240">
              <template slot-scope="scope">
                <el-input v-model="scope.row.invoiceProjectName" size="mini" clearable placeholder="请输入该供应商的开票项目名称"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="72" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" class="danger-text" @click="removeSupplierInvoiceProjectName(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="invoiceInfoDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleInvoiceInfoConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="转换导出" :visible.sync="convertDialogVisible" :close-on-click-modal="false" width="760px">
      <div class="convert-export-tip">上传成都产品表格。支持透明花熊、基础透明、基础磁吸、磨砂基础磁吸、方形纯色透明、磁吸方形透明，以及后两者的调色款。优先用 SKU 里的颜色和机型匹配，SKU 取系统子商品。同一名称有多条时按店铺对应。原列保留，右侧追加转换后的名称、颜色、型号、SKU 和店铺。</div>
      <el-upload ref="convertUpload" action="" :auto-upload="false" :show-file-list="false" accept=".xlsx,.xls" :on-change="onConvertFileChange">
        <el-button size="small" type="primary" :loading="convertParsing">选择表格</el-button>
      </el-upload>
      <div v-if="convertFileName" class="convert-export-file">{{ convertFileName }}</div>
      <div v-if="convertSummary.total" class="convert-export-summary">共 {{ convertSummary.total }} 行，已匹配 {{ convertSummary.matched }}，未匹配 {{ convertSummary.unmatched }}，匹配到多条 {{ convertSummary.multi }}</div>
      <el-table v-if="convertUnmatchedPreview.length" :data="convertUnmatchedPreview" border size="mini" max-height="240" class="convert-export-preview">
        <el-table-column prop="sku" label="SKU" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="color" label="产品颜色" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="model" label="机型" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="result" label="匹配结果" width="120"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="convertDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="convertParsing || convertRows.length === 0" @click="downloadConvertResult">下载转换表</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { colors, iPhoneModels, products, getPhoneCaseContantInfo } from "../../utils/constant.js";
import ProductKeywordAnalyze from "./ProductKeywordAnalyze.vue";
import { buildConvertSheet, attachChildSkus } from "./flowerBearConvert.js";
export default {
  data() {
    return {
      screenHeight: 400,
      loading: false,
      statusFilter: 1,
      statusOptions: [
        { value: "", label: "全部" },
        { value: 1, label: "启用" },
        { value: 0, label: "停用" },
      ],
      checkAll: false,
      isIndeterminate: true,
      beginIndex: 0,
      colors: colors,
      models: [],
      iPhoneModels: iPhoneModels,
      productLists: products,
      checkedModels: [],
      checkedColors: [],
      productInfo: {
        productName: "",
        skuPrefix: "",
        skuPrefix2: "",
        title: "",
        des1: "",
        des2: "",
        des3: "",
        des4: "",
        des5: "",
        des6: "",
        des7: "",
        des8: "",
        des9: "",
        des10: "",
        searchTerms: "",
        checkColors: [],
        checkModels: [],
        defaultModel: "",
        defaultColor: "",
        defaultColorName: "",
        cost: 1.2,
        shopType: 1,
        status: 1,
        categoryType: 1,
        isHasModel: 1,
        country: 1,
        perSKUOrderQuantity: 5,
        isMajorProduct: 0,
      },
      parentProductDialogVisible: false,
      colorDialogVisible: false,
      configMaterialDialogVisible: false,
      invoiceInfoDialogVisible: false,
      invoiceProductInfo: {},
      invoiceForm: {
        productType: "",
        productName: "",
        customsName: "",
        defaultInvoiceProjectName: "",
        supplierInvoiceProjectNames: [],
      },
      supplierList: [],
      products: [],
      multipleSelection: [],
      colorInfo: {
        name: "",
        key: "",
        jpKey: "",
      },
      materialConfig: [],
      materials: [],
      isColorEdit: 2,
      fbaFees: [],
      convertDialogVisible: false,
      convertParsing: false,
      convertFileName: "",
      convertHeaders: [],
      convertRows: [],
      convertSummary: {
        total: 0,
        matched: 0,
        unmatched: 0,
        multi: 0,
      },
      convertUnmatchedPreview: [],
    };
  },
  watch: {
    "productInfo.checkColors"(newCheckColors, oldValue) {
      if (!newCheckColors) {
        return;
      }

      let list = [];
      newCheckColors.forEach(color => {
        let info = this.colors.find(item => item.key == color);
        info && list.push(info);
      });
      this.checkedColors = list;
    },
    "productInfo.checkModels"(newCheckModels, oldValue) {
      if (!newCheckModels) {
        return;
      }

      let list = [];
      newCheckModels.forEach(model => {
        let info = this.iPhoneModels.find(item => item.model == model);
        info && list.push(info);
      });
      this.checkedModels = list;
    },
  },
  mounted() {
    this.getAllProducts();
    this.fetchMaterials();
    this.fetchSuppliers();
    this.calculateHeight();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.tablePanel;
        if (!panel) {
          return;
        }
        const panelStyle = window.getComputedStyle(panel);
        const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
        const availableHeight = panel.clientHeight - paddingTop - paddingBottom - 8;
        this.screenHeight = Math.max(availableHeight, 200);
      });
    },
    editColor(color) {
      this.colorDialogVisible = true;
      this.colorInfo = color;
    },
    fetchMaterials() {
      requestModules
        .fetchMaterials({ pageSize: 10000 })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "获取列表失败",
            });
            return;
          }

          this.materials = res.ldata;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
    fetchSuppliers() {
      requestModules.fetchSuppliers({ beginIndex: 0, pageSize: 1000 }).then(res => {
        this.supplierList = res.ldata || [];
      });
    },
    fetchExportFBAFees() {
      requestModules
        .fetchExportFBAFees({})
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "获取列表失败",
            });
            return;
          }

          this.fbaFees = res.ldata;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },

    addOneMaterial() {
      this.materialConfig.push({
        materialColor: "",
        materialId: "",
        color: "",
        count: 1,
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    handleCheckAllChange(val) {
      this.models = [];
      this.iPhoneModels.forEach(item => {
        this.models.push(item.model);
      });

      this.productInfo.checkModels = val ? this.models : [];
      this.isIndeterminate = false;
    },
    handleCheckNoneChange() {
      this.productInfo.checkModels = [];
      this.productInfo.defaultModel = "";
    },
    getAllProducts() {
      const params = {};
      if (this.statusFilter !== "") {
        params.status = this.statusFilter;
      }
      this.loading = true;
      requestModules
        .fetchParentProducts(params)
        .then(res => {
          this.products = res.ldata || [];
          this.products.sort((a, b) => b.productType - a.productType);
        })
        .finally(() => {
          this.loading = false;
          this.calculateHeight();
        });
    },
    handleRowAction(command, row) {
      if (command === "delivery") {
        this.deliverykeywordConfig(row);
      } else if (command === "keyword") {
        this.keywordAnalyze(row);
      } else if (command === "material") {
        this.configMaterial(row);
      } else if (command === "invoice") {
        this.configInvoiceInfo(row);
      }
    },
    configMaterial(row) {
      this.productInfo = { ...row };
      // this.productInfo.checkColors = JSON.parse(row.checkColors);
      // this.productInfo.checkModels = JSON.parse(row.checkModels);
      this.configMaterialDialogVisible = true;
      this.materialConfig = row.materialConfig && row.materialConfig.length > 0 ? row.materialConfig : [{ materialColor: "", materialId: "", color: "", count: 1 }];
    },
    parseSupplierInvoiceProjectNames(value) {
      if (!value) {
        return [];
      }
      if (Array.isArray(value)) {
        return value.map(item => ({
          supplierId: item.supplierId,
          supplierName: item.supplierName || "",
          invoiceProjectName: item.invoiceProjectName || "",
        }));
      }
      try {
        let parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          return parsed.map(item => ({
            supplierId: item.supplierId,
            supplierName: item.supplierName || "",
            invoiceProjectName: item.invoiceProjectName || "",
          }));
        }
      } catch (err) {
        // ignore
      }
      return [];
    },
    getCustomsName(row) {
      return row.customsName || row.productName || "";
    },
    getInvoiceProjectNameDisplay(row) {
      let lines = [];
      if (row.defaultInvoiceProjectName) {
        lines.push(row.defaultInvoiceProjectName);
      }
      let supplierConfigs = this.parseSupplierInvoiceProjectNames(row.supplierInvoiceProjectNames);
      supplierConfigs.forEach(item => {
        if (!item.supplierId && !item.invoiceProjectName) {
          return;
        }
        let supplierName = item.supplierName;
        if (!supplierName && item.supplierId) {
          let supplier = this.supplierList.find(s => s.supplierId == item.supplierId);
          supplierName = supplier ? supplier.supplierShortName : item.supplierId;
        }
        lines.push((supplierName || "供应商") + "：" + (item.invoiceProjectName || "-"));
      });
      return lines.length ? lines.join("\n") : "-";
    },
    configInvoiceInfo(row) {
      this.invoiceProductInfo = { ...row };
      this.invoiceForm = {
        productType: row.productType || "",
        productName: row.productName || "",
        customsName: row.customsName || row.productName || "",
        defaultInvoiceProjectName: row.defaultInvoiceProjectName || "",
        supplierInvoiceProjectNames: this.parseSupplierInvoiceProjectNames(row.supplierInvoiceProjectNames),
      };
      this.invoiceInfoDialogVisible = true;
    },
    getEffectiveCustomsName() {
      return (this.invoiceForm.customsName || this.invoiceForm.productName || "").trim() || "-";
    },
    resetCustomsName() {
      this.invoiceForm.customsName = this.invoiceForm.productName || "";
    },
    addSupplierInvoiceProjectName() {
      this.invoiceForm.supplierInvoiceProjectNames.push({
        supplierId: "",
        supplierName: "",
        invoiceProjectName: "",
      });
    },
    removeSupplierInvoiceProjectName(index) {
      this.invoiceForm.supplierInvoiceProjectNames.splice(index, 1);
    },
    onSupplierInvoiceProjectChange(row) {
      let supplier = this.supplierList.find(item => item.supplierId == row.supplierId);
      row.supplierName = supplier ? supplier.supplierShortName : "";
      if (!row.invoiceProjectName && this.invoiceForm.defaultInvoiceProjectName) {
        row.invoiceProjectName = this.invoiceForm.defaultInvoiceProjectName;
      }
    },
    handleInvoiceInfoConfirmBtn() {
      let supplierInvoiceProjectNames = (this.invoiceForm.supplierInvoiceProjectNames || []).filter(item => item.supplierId);
      let supplierIds = supplierInvoiceProjectNames.map(item => item.supplierId);
      if (new Set(supplierIds).size !== supplierIds.length) {
        this.$message.error("同一供应商不能重复配置开票项目名称");
        return;
      }

      this.invoiceInfoDialogVisible = false;
      let product = { ...this.invoiceProductInfo };
      product.customsName = (this.invoiceForm.customsName || this.invoiceForm.productName || "").trim();
      product.defaultInvoiceProjectName = (this.invoiceForm.defaultInvoiceProjectName || "").trim();
      product.supplierInvoiceProjectNames = JSON.stringify(
        supplierInvoiceProjectNames.map(item => ({
          supplierId: item.supplierId,
          supplierName: item.supplierName || "",
          invoiceProjectName: (item.invoiceProjectName || "").trim(),
        }))
      );
      requestModules
        .updateParentProduct(product)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "保存失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getAllProducts();
        })
        .catch(err => {
          console.log(err);
        });
    },
    onAddProductBtnClick() {
      this.productInfo = {
        productName: "",
        skuPrefix: "",
        skuPrefix2: "",
        title: "",
        des1: "",
        des2: "",
        des3: "",
        des4: "",
        des5: "",
        des6: "",
        des7: "",
        des8: "",
        des9: "",
        des10: "",
        searchTerms: "",
        checkColors: [],
        checkModels: [],
        defaultModel: "",
        defaultColor: "",
        defaultColorName: "",
        cost: 1.2,
        shopType: 1,
        status: 1,
        categoryType: 1,
        isHasModel: 1,
        country: 1,
        perSKUOrderQuantity: 5,
        isMajorProduct: 0,
      };
      this.parentProductDialogVisible = true;
      // this.addAllProduct();

      // this.fetchExportFBAFees();
    },
    editProduct(row) {
      this.productInfo = { ...row };

      // 兼容isHasModel的历史数据
      this.productInfo.isHasModel == undefined && (this.productInfo.isHasModel = 1);
      // this.productInfo.perSKUOrderQuantity == undefined && (this.productInfo.perSKUOrderQuantity = 5);

      this.productInfo.checkColors = Array.isArray(row.checkColors) ? row.checkColors : JSON.parse(row.checkColors);
      this.productInfo.checkModels = Array.isArray(row.checkModels) ? row.checkModels : JSON.parse(row.checkModels);
      this.parentProductDialogVisible = true;
    },
    childProduct(row) {
      window.open("/client/parentProductMgmt/childProductMgmt?productType=" + row.productType);
    },
    onlineStatus(row) {
      window.open("/client/parentProductMgmt/onlineStatus?productType=" + row.productType);
    },
    keywordAnalyze(row) {
      window.open("/client/parentProductMgmt/productKeywordAnalyze?productType=" + row.productType);
    },
    deliverykeywordConfig(row) {
      window.open("/client/parentProductMgmt/ProductKeywordDeliveryMgmt?productType=" + row.productType);
    },
    goColorMgmt() {
      window.open("/client/parentProductMgmt/colorMgmt");
    },
    handleConfirmBtn() {
      if (this.productInfo.productName == "" || this.productInfo.title == "" || this.productInfo.skuPrefix == "") {
        this.$message({
          type: "error",
          message: "请完善必填信息",
        });
        return;
      }

      this.parentProductDialogVisible = false;
      let product = { ...this.productInfo };
      product.checkColors = JSON.stringify(this.productInfo.checkColors);
      product.checkModels = JSON.stringify(this.productInfo.checkModels);
      product.shopName = this.getShopName(this.productInfo.shopType);
      product.defaultColorName = this.getColorName(this.productInfo.defaultColor);
      (product.perSKUOrderQuantity <= 0 || !product.perSKUOrderQuantity) && (product.perSKUOrderQuantity = 5);
      requestModules
        .updateParentProduct(product)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "编辑失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getAllProducts();
        })
        .catch(err => {
          console.log(err);
        });
    },
    addNewColor() {
      this.colorDialogVisible = true;
      this.colorInfo = {
        name: "",
        key: "",
        jpKey: "",
      };
    },
    handleConfigMaterialConfirmBtn() {
      this.configMaterialDialogVisible = false;

      let product = { ...this.productInfo };
      this.materialConfig.forEach(config => {
        let list = config.materialColor.split("-");
        config.materialId = list[0];
        config.color = "";
        list.length > 1 && (config.color = list[1]);
      });
      console.log(this.materialConfig);

      product.materialConfig = JSON.stringify(this.materialConfig);
      product.checkColors = JSON.stringify(this.checkColors);
      product.checkModels = JSON.stringify(this.checkModels);
      requestModules
        .updateParentProduct(product)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "编辑失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getAllProducts();
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleColorConfirmBtn() {
      if (this.colorInfo.name == null || this.colorInfo.key == "") {
        this.$message({
          type: "error",
          message: "请输入完整颜色信息",
        });
        return;
      }

      requestModules
        .addColor(this.colorInfo)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "新增失败",
            });
            return;
          }

          this.colorDialogVisible = false;
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          getPhoneCaseContantInfo();
        })
        .catch(err => {
          console.log(err);
        });
    },
    deleteMateral(index) {
      this.materialConfig.splice(index, 1);
      console.log(this.materialConfig);
    },
    getShopName(shopType) {
      let shopName = "灵柚";
      shopType == 1 && (shopName = "灵柚");
      shopType == 2 && (shopName = "萧发");
      shopType == 3 && (shopName = "誉腾");
      shopType == 4 && (shopName = "甄昂");
      shopType == 8 && (shopName = "众联");
      return shopName;
    },
    getColorName(colorType) {
      let color = this.colors.find(color => color.key == colorType);
      return color && color.name;
    },
    getExportProductName() {
      return "产品描述_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
    getExportFBAFeeName() {
      return "FBAFee_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
    getJsonParseStr(str) {
      console.log("colors", str);
      if (!str) {
        return "";
      }
      return JSON.parse(str).join(",");
    },
    getColorLabel(colorType) {
      let color = this.colors.find(color => color.key == colorType);
      return color ? color.name : "";
    },
    getMaterialConfigText(materialConfig) {
      if (!materialConfig) {
        return "";
      }
      let txt = "";
      materialConfig.forEach((config, index) => {
        txt += "材料" + ++index + "：" + this.getMaterialName(config.materialId);
        config.color && config.color != "" && (txt += "-" + this.getColorName(config.color));
        txt += "-" + config.count + "个；";
      });
      return txt;
    },
    getMaterialName(materialId) {
      let material = this.materials.find(m => m.materialId == materialId);
      return material ? material.materialName : "";
    },
    getMaterialColorName(materialId) {
      let material = this.materials.find(m => m.materialId == materialId);
      return material ? material.colorName : "";
    },
    openConvertExport() {
      this.resetConvertResult();
      this.convertDialogVisible = true;
    },
    resetConvertResult() {
      this.convertParsing = false;
      this.convertFileName = "";
      this.convertHeaders = [];
      this.convertRows = [];
      this.convertSummary = {
        total: 0,
        matched: 0,
        unmatched: 0,
        multi: 0,
      };
      this.convertUnmatchedPreview = [];
    },
    onConvertFileChange(file) {
      const raw = file && file.raw;
      if (!raw) {
        return;
      }
      const name = (raw.name || "").toLowerCase();
      if (!name.endsWith(".xlsx") && !name.endsWith(".xls")) {
        this.$message.error("请上传 xlsx 或 xls 文件");
        return;
      }
      this.parseConvertFile(raw);
      if (this.$refs.convertUpload) {
        this.$refs.convertUpload.clearFiles();
      }
    },
    async parseConvertFile(file) {
      this.convertParsing = true;
      this.convertFileName = file.name || "";
      this.convertHeaders = [];
      this.convertRows = [];
      this.convertSummary = {
        total: 0,
        matched: 0,
        unmatched: 0,
        multi: 0,
      };
      this.convertUnmatchedPreview = [];
      try {
        const XLSXModule = await import("xlsx/dist/xlsx.full.min.js");
        const XLSX = XLSXModule.default || XLSXModule;
        const buffer = await file.arrayBuffer();
        const workbook = XLSX.read(buffer, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        if (!sheetName) {
          this.$message.error("表格没有可读取的工作表");
          return;
        }
        const matrix = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1, defval: "", raw: false });
        const products = await this.loadConvertProducts();
        const built = buildConvertSheet(matrix, products, this.colors);
        if (built.error) {
          this.$message.error(built.error);
          return;
        }
        const productTypes = (built.rowMeta || []).map(item => item.productType);
        const childProducts = await this.loadChildProducts(productTypes);
        attachChildSkus(built, childProducts);
        this.convertHeaders = built.headers;
        this.convertRows = built.rows;
        this.convertSummary = built.summary;
        this.convertUnmatchedPreview = built.preview;
      } catch (err) {
        this.$message.error(err && err.message ? err.message : "解析表格失败");
      } finally {
        this.convertParsing = false;
      }
    },
    loadChildProducts(productTypes) {
      const types = [];
      (productTypes || []).forEach(productType => {
        if (productType !== "" && productType != null && types.indexOf(productType) === -1) {
          types.push(productType);
        }
      });
      if (!types.length) {
        return Promise.resolve([]);
      }
      return Promise.all(
        types.map(productType =>
          requestModules
            .fetchProductsByType({ productType, beginIndex: 0, pageSize: 10000 })
            .then(res => (res && res.ldata) || [])
            .catch(() => [])
        )
      ).then(lists => lists.reduce((all, list) => all.concat(list), []));
    },
    loadConvertProducts() {
      return requestModules
        .fetchAllParentProducts({})
        .then(res => {
          const list = res && res.ldata;
          if (Array.isArray(list) && list.length) {
            return list;
          }
          return this.products;
        })
        .catch(() => this.products);
    },
    async downloadConvertResult() {
      if (!this.convertRows.length) {
        return;
      }
      try {
        const XLSXModule = await import("xlsx/dist/xlsx.full.min.js");
        const XLSX = XLSXModule.default || XLSXModule;
        const sheet = XLSX.utils.aoa_to_sheet([this.convertHeaders].concat(this.convertRows));
        const book = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(book, sheet, "转换结果");
        const filename = "产品转换_" + new Date().format("yyyy-MM-dd_hh-mm-ss") + ".xlsx";
        XLSX.writeFile(book, filename);
      } catch (err) {
        this.$message.error(err && err.message ? err.message : "下载失败");
      }
    },
  },
  computed: {
    fbaFeeTitles() {
      let fields = {
        "店铺": "shopName",
        "产品名称": "productName",
        "颜色": "productColorName",
        "型号": "model",
        "Asin": "asin",
        "SKU": '?"sku"',
        "FNSKU": "fnsku",
        "售价": "your-price",
        "尺寸类型": "product-size-tier",
        "长": "longest-side",
        "宽": "median-side",
        "高": "shortest-side",
        "重量": "item-package-weight",
        "90日订单": "last90DayCount",
        "库存": "inventoryCount",
        "总费用": "estimated-fee-total",
        "佣金": "estimated-referral-fee-per-unit",
        "FBA配送费": "expected-fulfillment-fee-per-unit",
        "父商品状态": "parentStatus",
        // "五点描述10": "des10",
        // "五点描述10": "des10",
        // "五点描述10": "des10",
        // "五点描述10": "des10",
        // "五点描述10": "des10",
        // "五点描述10": "des10",
        // "五点描述10": "des10",
      };
      return fields;
    },
    productTitles() {
      let fields = {
        "店铺": "shopName",
        "产品名称": "productName",
        "采购颜色": "purchaseColor",
        "型号": "model",
        "SKU": "sku",
        "标题": "title",
        "五点描述1": "des1",
        "五点描述2": "des2",
        "五点描述3": "des3",
        "五点描述4": "des4",
        "五点描述5": "des5",
      };
      return fields;
    },
    productData() {
      let list = [];
      let productConfigList = [];
      this.multipleSelection.forEach(product => {
        let checkColors = Array.isArray(product.checkColors) ? product.checkColors : JSON.parse(product.checkColors);
        let checkModels = Array.isArray(product.checkModels) ? product.checkModels : JSON.parse(product.checkModels);

        let data = {
          baseSku: product.skuPrefix,
          models: [],
          colors: checkColors,
          title: product.title,
          desList: [product.des1 ? product.des1 : "", product.des2 ? product.des2 : "", product.des3 ? product.des3 : "", product.des4 ? product.des4 : "", product.des5 ? product.des5 : ""],
          purchaseColors: product.purchaseColors ? JSON.parse(product.purchaseColors) : [],
          shopName: product.shopName,
          productName: product.productName,
        };
        // let checkModels = JSON.parse(product.checkModels);
        checkModels.forEach(checkModel => {
          let model = iPhoneModels.find(iPhoneModel => iPhoneModel.model == checkModel);
          model && data.models.push(model);
        });
        productConfigList.push(data);
      });

      console.log(productConfigList);
      productConfigList.forEach(config => {
        let { models, colors, desList, baseSku, title, shopName, productName, purchaseColors} = { ...config };

        colors.forEach(color => {
          let colorInfo = {
            sku: baseSku,
            title: title,
            shopName,
            productName
          };
          desList.forEach((des, index) => {
            colorInfo["des" + (index + 1)] = des;
          });

          let colorReg = new RegExp("_color_", "igm");
          let blankReg = new RegExp(" ", "igm");
          let shortWidthReg = new RegExp("-", "igm");
          colorInfo.sku = color == "" ? colorInfo.sku : colorInfo.sku + color.replace(blankReg, "-");
          colorInfo.title = colorInfo.title.replace(colorReg, color.replace(shortWidthReg, " "));

          let purchaseColorInfo = purchaseColors.find(item => item.productColor == color);
          colorInfo.purchaseColor = purchaseColorInfo ? purchaseColorInfo.purchaseColorName : "";

          desList.forEach((des, index) => {
            colorInfo["des" + (index + 1)] = colorInfo["des" + (index + 1)].replace(colorReg, color);
          });

          if (models.length == 0) {
            list.push(colorInfo);
          }

          models.forEach(iPhoneModel => {
            let modelInfo = {
              ...colorInfo,
            };

            let modelReg = new RegExp("_model_", "igm");
            let yearReg = new RegExp("_year_", "igm");
            let sizeReg = new RegExp("_size_", "igm");
            let inchReg = new RegExp("_inch_", "igm");
            let blankReg = new RegExp(" ", "igm");

            modelInfo.sku = modelInfo.sku + "-" + iPhoneModel.model.replace(blankReg, "");
            modelInfo.title = modelInfo.title.replace(modelReg, iPhoneModel.model).replace(yearReg, iPhoneModel.year).replace(sizeReg, iPhoneModel.size).replace(inchReg, iPhoneModel.inch);
            modelInfo.model = iPhoneModel.model;

            desList.forEach((des, index) => {
              modelInfo["des" + (index + 1)] = modelInfo["des" + (index + 1)].replace(modelReg, iPhoneModel.model).replace(yearReg, iPhoneModel.year).replace(sizeReg, iPhoneModel.size).replace(inchReg, iPhoneModel.inch);
            });

            list.push(modelInfo);
          });
        });
      });

      return list;
    },
    materialColorLists() {
      let list = [];

      this.materials.forEach(material => {
        list.push({
          materialId: material.materialId,
          materialName: material.materialName,
          materialColor: material.materialId.toString(),
        });
        if (material.colorList && material.colorList.length > 0) {
          material.colorList.forEach(color => {
            list.push({
              materialId: material.materialId,
              materialName: material.materialName + "-" + this.getColorLabel(color),
              color: color,
              materialColor: material.materialId + "-" + color,
            });
          });
        } else {
          list.push({
            materialId: material.materialId,
            materialName: material.materialName + "-" + this.getColorLabel(material.colorType),
            materialColor: material.materialId + "-" + material.colorType,
          });
        }
      });
      return list;
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

.parent-product-mgmt-page {
  .header-box {
    padding: 10px;

    .filter-toolbar {
      margin-top: 4px;
      padding-top: 10px;
      border-top: 1px dashed #ebeef5;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .filter-actions .el-button {
      width: auto;
      min-width: auto;
      margin: 0;
    }
  }

  .invoice-name-cell {
    white-space: pre-line;
    line-height: 1.5;
    max-height: 3em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .material-config-cell {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .text-muted {
    color: #c0c4cc;
  }

  .action-cell {
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  .convert-export-tip {
    margin: 0 0 12px;
    color: #606266;
    font-size: 13px;
    line-height: 1.6;
  }

  .convert-export-file {
    margin-top: 8px;
    color: #909399;
    font-size: 12px;
  }

  .convert-export-summary {
    margin-top: 12px;
    color: #303133;
    font-size: 13px;
  }

  .convert-export-preview {
    margin-top: 12px;
  }
}

.no-padding {
  padding: 0px !important;
  .cell {
    padding: 0px !important;
  }
}
.form-line {
  .form-label {
    margin: 5px 10px 5px 0px;
    width: 80px;
    text-align: right;
    display: inline-block;
    span {
      color: red;
    }
  }
  .form-input {
    width: 800px;
    margin: 5px 0px;
    vertical-align: top;
  }
  .form-group {
    width: 700px;
    margin: 5px 0px;
    display: inline-block;
    vertical-align: top;

    .el-checkbox {
      width: 70px;
    }
    .el-radio {
      width: 70px;
    }
  }

  .color-box {
    width: 700px;
    margin: 5px 0px;
    display: inline-block;
    vertical-align: top;

    .color-item {
      display: inline-block;
      width: 80px;
      cursor: pointer;
      color: #409eff;
    }
  }
}

.parent-product-invoice-dialog {
  .invoice-dialog-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .invoice-section {
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 14px 16px;
  }

  .invoice-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    &.compact {
      margin-bottom: 10px;
    }
  }

  .invoice-section-title {
    color: #303133;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    padding-left: 8px;
    border-left: 3px solid #409eff;
  }

  .invoice-basic-section {
    padding: 16px 18px;
  }

  .invoice-product-summary {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px 14px;
    margin-bottom: 14px;
    background: linear-gradient(135deg, #f5f9ff 0%, #eef4ff 100%);
    border: 1px solid #d9e8ff;
    border-radius: 8px;
  }

  .invoice-product-meta {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .invoice-product-type-tag {
    display: inline-flex;
    align-items: center;
    height: 22px;
    padding: 0 8px;
    border-radius: 11px;
    background: #409eff;
    color: #fff;
    font-size: 12px;
    line-height: 1;
  }

  .invoice-product-label {
    color: #909399;
    font-size: 12px;
  }

  .invoice-product-name {
    color: #303133;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.4;
    word-break: break-all;
  }

  .invoice-form-panel {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 4px 16px;
  }

  .invoice-form-row {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 14px 0;
    border-bottom: 1px solid #f2f3f5;

    &:last-child {
      border-bottom: none;
    }
  }

  .invoice-form-label {
    flex-shrink: 0;
    width: 96px;
    padding-top: 7px;
    color: #606266;
    font-size: 13px;
    line-height: 1.4;
    text-align: right;
  }

  .invoice-form-content {
    flex: 1;
    min-width: 0;
  }

  .invoice-input-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .invoice-form-input {
    flex: 1;
    min-width: 0;
  }

  .invoice-form-tip {
    margin-top: 6px;
    color: #909399;
    font-size: 12px;
    line-height: 1.5;
  }

  .invoice-supplier-table {
    background: #fff;
  }

  .danger-text {
    color: #f56c6c;
  }
}
</style>
